// Autogenerated by sprite compiler (large sprites)

export interface ILargeSprite {
  k: string
  d: string
  f: string
}

export const largeSprites = {
}

